export default __webpack_public_path__ + "static/media/Spir.970072ca.png";